import '@web/shared-digital-library/icons/svg-originals/chevron-left.svg';
import MdmIcon from '~/components/atoms/Global/MdmIcon.vue';
var NavItemBranch = () => import('./NavItemBranch.vue');
var NavItemLeaf = () => import('./NavItemLeaf.vue');
var NavItemFolders = () => import('./NavItemFolders.vue');
var NavItemFlat = () => import('./NavItemFlat.vue');
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
export default {
  name: 'NavItemTree',
  components: {
    MdmIcon,
    NavItemBranch,
    NavItemLeaf,
    NavItemFolders,
    NavItemFlat,
    MdmLink
  },
  props: {
    level: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: '#'
    },
    items: {
      type: Array,
      required: true
    },
    mea: {
      type: Array,
      default: () => []
    },
    withColor: {
      type: Boolean,
      default: false
    },
    isMenuOpened: {
      type: Boolean,
      default: true
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    branches() {
      return this.$refs['nav-item-branch'] || [];
    }
  },
  methods: {
    isScrambleTransformation(item) {
      return !!(item.isScrambleLink || this.isScrambleLink);
    },
    itemClass(type) {
      if (type === 'card') {
        return 'pb-3';
      }
      if (this.level > 1 && type === 'linksList' && this.items.length > 1) {
        return null;
      }
      return 'item';
    },
    seeMoreClass(type) {
      if (type === 'cardsList') {
        return 'pb-3';
      }
      if (type === 'wrapper' && this.items.length > 1 && this.items.every(i => i.type === 'linksList')) {
        return null;
      }
      return 'item';
    },
    componentName(type) {
      if (type === 'link' || type === 'card') {
        return 'nav-item-leaf';
      }
      if (this.level > 1 && type === 'linksList' && this.items.length > 1) {
        return 'nav-item-folders';
      }
      if (this.level > 1 && type === 'linksList' && this.items.length === 1) {
        return 'nav-item-flat';
      }
      return 'nav-item-branch';
    },
    close() {
      this.branches.forEach(branch => branch.close());
    }
  }
};